import React from "react";
import { Box, Typography, Button, IconButton } from "@mui/material";
import { Add } from "@mui/icons-material";
import { useDocketsContext } from "providers/DocketsProvider";

export default function BreakoutsMenubar({ isMobile }) {
  const { loadRoute, docketPermissions } = useDocketsContext();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        flexGrow: 1,
        justifyContent: "flex-end",
        alignItems: "center",
        pb: 1,
        ml: 2,
        mt: 2,
      }}
    >
      {docketPermissions.canAddNew &&
        (!isMobile ? (
          <Button
            variant="outlined"
            size="small"
            startIcon={<Add />}
            onClick={() => loadRoute("CREATE-DOCKET", {})}
          >
            Add New
          </Button>
        ) : (
          <IconButton onClick={() => loadRoute("CREATE-DOCKET", {})}>
            <Add />
          </IconButton>
        ))}
    </Box>
  );
}
